
<template>
    <div class="CommonPop" v-if="reexamination">
      <div class="head">
          提示
          <div class="icon" @click="popHide('1')">
            <img src="../../assets/images/close.svg" >
          </div>
          <div class="co">
            <img src="../../assets/images/mark.png" alt="">
          </div>
          <div class="cont">
              系统检测您上次{{textCommonPop}}，是否继续操作
          </div>   
          <div class="btnWrap">
              <div class="btn" @click="popHide('0')">重新考核</div><div class="btnN" @click="popHide('1')">继续操作</div>
          </div>
      </div>
    </div>
</template>
<script>
// import qs from 'qs'
export default {
  name: "CommonPop",
   data: function() {
    return {
      isShow:false
		}
  },
  props: [ 'reexamination','scoreFun','textCommonPop'],
  components: {
  },
  created(){
  },
   methods: {
     popHide(e){
	    this.scoreFun(e);
    },
  },
  
};
</script>
<style lang="scss" scoped>
.CommonPop{
	width: 400px;
	height: 235px;
	box-shadow:0px 0px 20px rgba(0,0,0,0.16);
	border-radius:2px;
	position: fixed;
	left: 50%;
  top: 50%;
  z-index: 9999;
  background-color: #fff;
  transform: translate(-50%, -50%);
  box-sizing: border-box;
  padding: 0  32px 0 34px;
  .head{
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    border-bottom:1px solid #E8E8E8;
    color: #000000;
    position: relative;
     .icon{
        position: absolute;
        right: -10px;
        top: 0px;
        cursor: pointer;
        img{
          width: 10px;
          height: 10px;
        }
      } 
  }
  .co{
    width:322px;
    line-height:20px;
    font-size:12px;
    margin-top: 12px;
    text-align: center;
  }
  .cont{
    text-align: center;
    line-height:20px;
    font-size:12px;
    margin: 0 auto;
    width:300px;
    padding-top: 25px;
  }
  .btnWrap{
    text-align: center;
    margin-top:34px;
    .btn{
      width:110px;
      height:32px;
      border-radius: 4px;
      background-color: #F3CD70;
      color: #232F3E;
      font-size:12px;
      display: inline-block;
      line-height: 32px;
      cursor: pointer;
      box-sizing: border-box;
      vertical-align: middle;
    }
    .btnN{
       width:110px;
      height:32px;
      border-radius: 4px;
      background-color: #FFFFFF;
      border:1px solid rgba(243,205,112,1);
      box-sizing: border-box;
      color: #57616C;
      font-size:12px;
      display: inline-block;
      line-height: 32px;
      cursor: pointer;
      margin-left: 10px;
      vertical-align: middle;
    }
  }
}
</style>
